import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

// Fires GA4 page_view on route change (SPA).
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // small delay to let react-helmet update <title>
    const t = setTimeout(() => {
      trackPageView(pathname + search, document.title);
    }, 100);
    return () => clearTimeout(t);
  }, [pathname, search]);

  return null;
}
